import React from 'react'

import * as S from './styles'

import IProps from './props'

import { numberToCurrency } from '../../helpers/helper-currency'

const PlanCard = ({
  period,
  values,
  promotionalPrice,
  selectedPlan,
  onChange,
  isUserPlan,
  id,
}: IProps) => (
  <S.Container selected={selectedPlan === id}>
    <S.PlanNameWithCheck>
      <S.Radio
        type="radio"
        name="plan"
        value={id}
        checked={selectedPlan === id}
        onChange={onChange}
      />
      <S.PlanName>
        {period}
        {' '}
        {isUserPlan && ' (seu plano atual)'}
      </S.PlanName>
    </S.PlanNameWithCheck>

    <S.PricesContainer>
      {promotionalPrice ? (
        <>
          <S.Price>{numberToCurrency(promotionalPrice)}</S.Price>
          {' '}
          <S.PriceDescount>
            {promotionalPrice && numberToCurrency(values)}
          </S.PriceDescount>
        </>
      ) : (
        <S.Price>{numberToCurrency(values)}</S.Price>
      )}
    </S.PricesContainer>
  </S.Container>
)

export default PlanCard
